import {
  Badge,
  Box,
  Button,
  Center,
  Flex,
  Icon,
  Image,
  Text,
  Tooltip,
  Wrap,
} from "@chakra-ui/react";
import { BiBookReader } from "react-icons/bi";
import { HiOutlineLockClosed, HiOutlineUsers } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { franchiseMapIndex } from "../../../core/constants";
import useStartReadingOrder from "../../../shared/hooks/useStartReadingOrder";

const MyReadingOrderCard = ({ readingOrder, url, openPublishModal }) => {
  const navigate = useNavigate();
  const { startReadingOrder } = useStartReadingOrder(false);
  const handleButtonClick = (e, targetUrl, state) => {
    e.stopPropagation(); // Prevents event from bubbling up to parent elements
    navigate(targetUrl, { state });
  };
  return (
    <Box
      bg="gray.700"
      borderRadius="lg"
      overflow="hidden"
      mb="4"
      cursor="pointer"
      onClick={() => navigate(`/my-orders/${readingOrder.id}`)}
    >
      <Flex>
        <Image
          src={readingOrder.thumbnail}
          alt={readingOrder.title}
          height="72px"
        />
        <Center width="100%">
          <Box width="100%" px="6">
            <Flex alignItems="center" direction="row">
              <Text fontWeight="bold">{readingOrder.title} &nbsp;</Text>
              {!readingOrder.published ? (
                <Badge fontSize="0.6em" variant="outline">
                  Draft
                </Badge>
              ) : (
                <>
                  {!!readingOrder.privacyMode ? (
                    <Tooltip
                      hasArrow
                      label="Shared with the Redwing community"
                      placement="right"
                      bg="black"
                      color="white"
                    >
                      <Wrap>
                        <Icon as={HiOutlineUsers} />
                      </Wrap>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      hasArrow
                      label="Private. Only you can see it"
                      placement="right"
                      bg="black"
                      color="white"
                    >
                      <Wrap>
                        <Icon as={HiOutlineLockClosed} />
                      </Wrap>
                    </Tooltip>
                  )}
                </>
              )}
            </Flex>
            <Text fontSize="small">
              {`${franchiseMapIndex[readingOrder.franchise]} • `}
              {`${readingOrder.comicsCount} comics`}
              {!!readingOrder.years && ` •  ${readingOrder.years}`}
              {` • `}
              <Icon as={BiBookReader} /> {readingOrder.readingCount || 0}{" "}
              {readingOrder.readingCount === 1 ? "reader" : "readers"}
            </Text>
          </Box>
        </Center>
        <Center px="3">
          {!!readingOrder.published && (
            <Button
              size="sm"
              variant="ghost"
              onClick={(e) => {
                e.stopPropagation();
                startReadingOrder(readingOrder.id, readingOrder.franchise);
              }}
              mr="2"
            >
              Read
            </Button>
          )}
          <Button
            size="sm"
            onClick={(e) => handleButtonClick(e, url, { readingOrder })}
          >
            Edit order
          </Button>
          {!readingOrder.published && readingOrder.comicsCount > 1 && (
            <Button
              onClick={(e) => {
                e.stopPropagation();
                openPublishModal(readingOrder);
              }}
              size="sm"
              colorScheme="blue"
              textColor="white"
              ml="2"
            >
              Publish
            </Button>
          )}
        </Center>
      </Flex>
    </Box>
  );
};

export default MyReadingOrderCard;
